/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseMetaNotificationResponse } from '../../models/api-response-meta-notification-response';

export interface GetNotifications$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
  unreadOnly?: boolean;
  page?: number;
  size?: number;
}

export function getNotifications(http: HttpClient, rootUrl: string, params: GetNotifications$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseMetaNotificationResponse>> {
  const rb = new RequestBuilder(rootUrl, getNotifications.PATH, 'get');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.query('unreadOnly', params.unreadOnly, {});
    rb.query('page', params.page, {});
    rb.query('size', params.size, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseMetaNotificationResponse>;
    })
  );
}

getNotifications.PATH = '/v1/api/ui/meta-notification';
